import { getPlayerById, getTeamInfoById, getVisualTimer } from "../../../../../../../sports/genericUtils.js"
import GenericScore from "../generic/GenericScore.js";

const RugbyEssai = ({item, match, icon}) => {

    const {text, title, team, buteur, period, timer} = item.detail
    
    const visualTimer = getVisualTimer(timer, period, match.discipline)
    const teamDetail = getTeamInfoById(team, match)
    const playerDetail = buteur === 'edp' ? 'Essai de pénalité' : getPlayerById(buteur, match)

    return (
      <GenericScore 
        teamDetail={teamDetail} 
        playerDetail={playerDetail} 
        visualTimer={visualTimer} 
        icon={icon}
        title={title}
        text={text}
        />
      );
}

export default RugbyEssai